var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var Select = require('./Select');

var MultiSelectField = createReactClass({
	displayName: 'MultiSelectField',
	propTypes: {
		label: PropTypes.string,
		options: PropTypes.array,
		labelKey: PropTypes.string,
		valueKey: PropTypes.string
		
	},
	render() {
		return (
	    	<label>{this.props.label}
      			<Select 
					name={this.props.name}
					value={this.props.value} 
					placeholder="Select" 
					options={this.props.options} 
					onChange={this.props.onChange}
					key={this.props.name}
					labelKey={this.props.labelKey}
					valueKey={this.props.valueKey}
					 />
      		</label>
    	);
}
});

module.exports = MultiSelectField;